<template>
  <a-input-group compact>
    <ll-select
      v-model:value="innerValue.method"
      :disabled="disabled"
      :options="methods"
      style="width: 150px"
      :allow-clear="false"
      @change="handleChange"
    />
    <ll-input
      v-model:value="innerValue.url"
      :disabled="disabled"
      style="width: 50%"
      placeholder="请输入地址（去除前置URL)"
      @input="handleChange"
    />
  </a-input-group>
</template>

<script setup lang="ts">
import { ref, inject, watch } from 'vue'
import { methods, apiUrlProps, apiUrlEmits, type HttpModel } from '../config'

const props = defineProps(apiUrlProps)
const emits = defineEmits(apiUrlEmits)

const disabled = inject('disabled')

const innerValue = ref<HttpModel>(props.value)

const handleChange = () => {
  emits('change', innerValue.value)
  emits('update:value', innerValue.value)
}

watch(
  () => props.value,
  val => {
    innerValue.value = val
  },
  {
    deep: true
  }
)
</script>

<style scoped></style>
